import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";


const Navlinks = () => {
  const currentPage = useSelector((state) => state.activePage);

  return (
    <div className="container-navlink-mobile">
      <div className="container-inner-navlink-mobile">
        <Link to="/" className={`              
              ${currentPage === "Produktmixern" 
                ? 'navlink-mobile-focused ' 
                : 'navlink-mobile'
              }
            `} >
          Utbudsmixer
        </Link>

        <Link to="/fastaKostnader" className={`              
              ${currentPage === "Fastakostnader" 
                ? 'navlink-mobile-focused ' 
                : 'navlink-mobile'
              }
            `} >
          Fasta Kostnader
        </Link>
      </div>
      <div className="container-inner-navlink-mobile">
        <Link to="/åtgärder" className={`              
              ${currentPage === "Åtgärder" 
                ? 'navlink-mobile-focused ' 
                : 'navlink-mobile'
              }
            `}>
          Åtgärder
        </Link>
        
        <Link to="/lonekalkyl" className={`              
              ${currentPage === "Lonekalkyl" 
                ? 'navlink-mobile-focused ' 
                : 'navlink-mobile'
              }
            `}>
          Lönekalkyl
        </Link>
      </div>
    </div>
  );
};
export default Navlinks;
